module.exports = __webpack_public_path__ + "media/packs/images/flags/TM-53639106c9af41658cc692e820d2d3e1.svg";